<template>
<div>
  <body>
    <div class="bsop">
      <h1 class="read-only">SDream & Dream 시즌 2 증정품 안내</h1>
      <section class="header">
        <div class="item">
          <div>
            <div>
              <h2><span>{{ couponInfo.coupon_name }}</span></h2>
              <p>{{ couponInfo.coupon_type }}</p>
            </div>
          </div>
          <div>
            <img :src="couponInfo.product_image" class="product" alt="제품">
            <p v-html="getProductNameForEnter(couponInfo.product_name)"></p>
          </div>
        </div>
      </section>
      <coupondetailvue 
        :propCouponInfo="this.propCouponInfo"
        :propCouponDetail="this.propCouponDetail"
        :aboInfo="this.aboInfo"
        :couponNo="this.couponNo"
      />
    </div>
  </body>
</div>
</template>
<script>

import coupondetailvue from './component/coupondetail.vue'
export default {
    metaInfo: {
    title: 'Dream & Dream 시즌 2 증정품 안내',
    meta: [
        { 'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8' },
        { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge' },
        { charset:'utf-8' },
        { name:'viewport', content:'width=device-width, initial-scale=1' },
        { name:'keywords'},
        { name:'description', content:'Dream And Dream'},
        { name:'robots', content:'index,follow'},
        { property:'og:description', content:'Dream & Dream 시즌 2 증정품 안내'},
        { property:'og:image', content:'./assets/images/kakao_thumb.jpg'}
    ]
    },
    name: 'dreamanddream',
    components:{
      coupondetailvue
    },
    props:{
      propCouponInfo: {},
		  propCouponDetail: [],
      aboInfo: {},
      couponNo: ''
    },
    data () {
      return {
        couponInfo: {},
      }
    },
    methods: {
      init: async function () { // 초기화
        this.couponInfo=this.propCouponInfo
      },
      getProductNameForEnter: function(pName){
          if(pName){
              return pName.replace(/(?:\r\n|\r|\n)/g, '<br />');
          }
          return pName
      },
    },
    mounted() {
      window.setTimeout(() => {
        this.ready = true
        this.init()
        }, 50)
    },  
}
</script>

<style scoped>
    @import './assets/style.css';
</style>



// WEBPACK FOOTER //
// src/views/couponsys/dreamanddream.vue